import { render, staticRenderFns } from "./AboutGS.vue?vue&type=template&id=dae90ca8&scoped=true"
import script from "./AboutGS.vue?vue&type=script&lang=js"
export * from "./AboutGS.vue?vue&type=script&lang=js"
import style0 from "./AboutGS.vue?vue&type=style&index=0&id=dae90ca8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae90ca8",
  null
  
)

export default component.exports